import dayjs from 'dayjs';

import { useUser } from '~/api/user';
import { clsx } from '~/styles/utils';

import { skeletonBlockStyle, statsGridSkeletonStyle, statsGridStyle, statsSectionStyle } from './StatsSummary.css';

export const StatsSummarySkeleton = () => {
  const { data: user } = useUser();

  return (
    <section className={statsSectionStyle}>
      <div className={clsx(statsGridStyle, statsGridSkeletonStyle)}>
        <div className={skeletonBlockStyle}></div>

        <div className={skeletonBlockStyle}></div>

        {dayjs(user.registeredAt).year() < dayjs().year() && <div className={skeletonBlockStyle}></div>}
      </div>
    </section>
  );
};
